import HeroBanner from "../components/landing/Hero";
import { AboutUs } from "../components/landing/AboutUs";
import Partners from "../components/landing/Partners";
import Offers from "../components/landing/Offers";
import Gallery from "../components/landing/Gallery";
import LatestNews from "../components/landing/LatestNews";
import { useEffect } from "react";
import { setMetaTag, setPropertyMetaTag } from "../helpers/seoUtils";

const HomePage = () => {
  useEffect(() => {
    document.title = "Economus – Playgrounds in Lithuania";

    setMetaTag(
      "description",
      "Economus specializes in safe, modern children’s playgrounds in Lithuania. We turn vision into reality with certified equipment and coatings."
    );
    setMetaTag(
      "keywords",
      "playgrounds, playgrounds in Lithuania, children’s playgrounds, Economus, vaikų žaidimų aikštelės, žaidimų aikštelės Lietuvoje, saugios aikštelės"
    );

    setPropertyMetaTag("og:title", "Economus – Playgrounds in Lithuania");
    setPropertyMetaTag(
      "og:description",
      "Safe and certified children's playgrounds and coatings. Based in Lithuania."
    );
    setPropertyMetaTag(
      "og:image",
      "https://economus.netlify.app/static/media/playground-1.2ce91d1e3b0027d15c26.webp"
    );
    setPropertyMetaTag("og:url", "https://economus.netlify.app/");
    setPropertyMetaTag("og:type", "website");

    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "Economus – Playgrounds in Lithuania");
    setMetaTag(
      "twitter:description",
      "Safe and certified children's playgrounds and coatings."
    );
    setMetaTag(
      "twitter:image",
      "https://economus.netlify.app/static/media/playground-1.2ce91d1e3b0027d15c26.webp"
    );

    setMetaTag("language", "lt");
    setMetaTag("geo.region", "LT");
    setMetaTag("geo.placename", "Lithuania");
    setMetaTag("robots", "index, follow");
  }, []);

  return (
    <>
      <HeroBanner />
      <AboutUs />
      <Partners />
      <Offers />
      <Gallery />
      <LatestNews />
    </>
  );
};

export default HomePage;
